// cspell:ignore lightpink
export const tableDraggingColor = "#f1f2bf";
